export { default as SwipeGesture } from './SwipeGesture';